import store from "../store";

const STATE_KEY = 'environment';
const SET_DETAILS = `${STATE_KEY}/SET_DETAILS`;
const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_DETAILS: {
      return action.payload;
    }
    default:
      return state;
  }
}

// export function setDetails(payload) {
//   return {
//     type: SET_DETAILS,
//     payload
//   };
// }

export function setDetails(payload) {
  store.dispatch({
    type: SET_DETAILS,
    payload,
  });
}
